import { render } from "./SettingsAccountPage.vue?vue&type=template&id=6dc38cea"
import script from "./SettingsAccountPage.vue?vue&type=script&lang=js"
export * from "./SettingsAccountPage.vue?vue&type=script&lang=js"

import "./SettingsAccountPage.vue?vue&type=style&index=0&id=6dc38cea&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__